
import type { Result } from '@empathyco/x-types'
import type { PropType } from 'vue'
import { QueryRankingElementRankingAction } from '@empathyco/playboard-core-domain'
import {
  BaseScroll,
  BaseVariableColumnGrid,
  infiniteScroll,
  StaggeredFadeAndSlide,
} from '@empathyco/x-components'
import { BannersList, ResultsList } from '@empathyco/x-components/search'
import { defineComponent } from 'vue'
import { ExplainUtils } from '../../utils'
import ResultCard from '../result-card.component.vue'

export default defineComponent({
  name: 'XResultsGrid',
  directives: {
    infiniteScroll,
  },
  components: {
    BannersList,
    BaseScroll,
    BaseVariableColumnGrid,
    ResultCard,
    ResultsList,
  },
  props: {
    resultsHoverDisabled: Boolean,
    selectedResultIds: {
      type: Array as PropType<Array<string>>,
      default: () => [],
    },
    messages: {
      type: Object,
    },
    errorDefaultImageBackgroundColor: {
      type: Boolean,
      default: () => false,
    },
  },
  setup() {
    const hasAttributeRankingAction = (result: Result, action: QueryRankingElementRankingAction) =>
      ExplainUtils.getAttributeQueryRankingActionFromResult(result) === action

    const isBoostedByAttribute = (result: Result) =>
      hasAttributeRankingAction(result, QueryRankingElementRankingAction.BOOST)

    const isBuriedByAttribute = (result: Result) =>
      hasAttributeRankingAction(result, QueryRankingElementRankingAction.BURY)

    return {
      baseClass: 'epb-x-results-grid',
      resultsAnimation: StaggeredFadeAndSlide,
      isBoostedByAttribute,
      isBuriedByAttribute,
    }
  },
})
